import {Component, Input, OnInit} from '@angular/core';
import {Log} from './log.model';
import {
  OrderByRequestParameters,
  RequestParameters,
  FieldRequestParameters
} from '../../models/request-parameters/parameter.model';
import {UserLogsService} from './user-logs.service';
import {PlatformConfig} from '../../../app-loader/platform-config';
import {ConfigLoaderService} from '../../../app-loader/config-loader.service';
import {MatDialog, MatDialogRef} from '@angular/material';
import { UserLogsDialogComponent } from './user-logs-dialog/user-logs-dialog.component';
import { LogFormatterUtils } from '../../utils/LogFormatterUtils';

import { Angular2Txt } from 'angular2-txt/Angular2-txt';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-user-logs',
  templateUrl: './user-logs.component.html',
  styleUrls: ['./user-logs.component.scss']
})
export class UserLogsComponent implements OnInit {
  // @Input('user') user: any;
  @Input('logsSack') logsSack: any;
  loading: boolean = false;
  parameters = new RequestParameters();
  platformConfig: PlatformConfig;
  logs: Log[] = [];
  dialogRef: MatDialogRef<UserLogsDialogComponent> | null;
  config = {
    disableClose: true,
    panelClass: 'custom-overlay-pane-class',
    hasBackdrop: true,
    backdropClass: '',
    width: '90%',
    height: '90%',
    position: {
      top: '',
      bottom: '',
      left: '',
      right: ''
    },
    data: {
      logDetails: []
    }
  };
  txtLoading: boolean = false;

  constructor(private userLogsService: UserLogsService,
              private dialog: MatDialog,
              private translateService: TranslateService,
              public configLoaderService: ConfigLoaderService) {
    this.platformConfig = this.configLoaderService.getPlatformConfig();
  }

  ngOnInit() {
    // this.updateData();
    // console.log(this.logsSack);
    if (this.logsSack) {
      this.logs = this.logsSack.result;
      this.parameters = this.logsSack.parameters;
      // console.log(this.logs);
    }
  }

  updateData() {
    this.loading = true;
    // this.parameters.fields = [];
    // this.parameters.fields.push(new FieldRequestParameters ('user', this.user.reference));
    // this.parameters.fields.push(new FieldRequestParameters ('userDest', this.user.reference));
    this.userLogsService.getLogs(this.parameters).subscribe(
      (response) => {
        this.parameters.setData(response.parameters);
        // console.log(this.parameters);
        this.logs = response.result;
        this.loading = false;
      }
    );
  }
  onSort(event) {
    const orderByParameter = new OrderByRequestParameters(event.sorts[0].prop, event.sorts[0].dir.toUpperCase());
    this.parameters.orderBy = [];
    this.parameters.orderBy.push(orderByParameter);
    this.updateData();
  }
  setPage(page) {
    this.parameters.offset = page.offset;
    this.updateData();
  }
  getEntity(value) {
    const lastBarIndex = value.lastIndexOf('\\');
    return  value.substring(lastBarIndex + 1).toUpperCase();
  }
  getEntityValue(value) {
    return JSON.parse(value).reference;
  }
  showDetails(row) {
    // console.log(row);
    // console.log(JSON.parse(row.entityValue));
    this.config.data.logDetails = LogFormatterUtils.logFormatter(row);
    this.dialogRef = this.dialog.open(UserLogsDialogComponent, this.config);
    this.dialogRef.afterClosed().subscribe((result: any) => {
    });
  }

  getObjectKey(obj) {
    return (Object.keys(obj))[0];
  }

  getObjectValue(obj): string {
    let str: any = (Object.values(obj))[0];
    return str;
  }

  getLogsToExport() {
    const logsMapped = this.logs.map(
      (log) => {
        const logFormatted = LogFormatterUtils.logFormatter(log);
        if (logFormatted) {
          let log_formatted_to_obejct = {};
          logFormatted.map(
            (log_f) => {
              log_formatted_to_obejct[this.getObjectKey(log_f)] = (this.getObjectValue(log_f) ? (
                isNaN(Number(this.getObjectValue(log_f))) ? this.translateService.instant(this.getObjectKey(log_f)) + ' : ' + this.translateService.instant(this.getObjectValue(log_f)) :
                this.translateService.instant(this.getObjectKey(log_f)) + ' : ' + this.getObjectValue(log_f)
              ) : '');
              // this.translateService.instant(this.getObjectValue(log_f));
            }
          );
          return log_formatted_to_obejct;
        } else {
          return {
            date: this.translateService.instant("date") + ' : ' +  log.date,
            action: this.translateService.instant("action") + ' : ' +  log.actionReference,
            user: this.translateService.instant("user") + ' : ' +  log.firstname + ' ' + log.lastname,
            userDest: this.translateService.instant("userDest") + ' : ' +  log.firstnameDest + ' ' + log.lastnameDest
          }
        }
      }
    );
    return logsMapped;
  }

  exportToTXT() {
    this.txtLoading = true;
    const data = this.getLogsToExport();
    var options = { 
      // headers: Object.keys(data[0]),
      fieldSeparator: '|',
      quoteStrings: '"',
      decimalseparator: '.',
      showTitle: false,
      useBom: true
    };
    new Angular2Txt(data, 'logs'+ Date.now(), options);
    this.txtLoading = false;
  }

}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/user-logs/user-logs.component.ts